export const formatDate = (date) => {
  const thisDate = new Date(date);
  const options = {
    // weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return thisDate.toLocaleDateString("en-US", options);
};

export const formatFuzzyDate = (date, howApproximate) => {
  const thisDate = new Date(date);
  const ca = "c.\u00A0";
  switch (howApproximate) {
    case "exact":
      return formatDate(date);
    case "decade":
      return ca + thisDate.toLocaleDateString("en-US", { year: "numeric" });
    case "year":
      return thisDate.toLocaleDateString("en-US", { year: "numeric" });
    case "month":
      return thisDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
      });
    case "day":
    default:
      return ca + formatDate(date);
  }
};

export const sortObjectsByDate = (listOfObjects) =>
  listOfObjects.sort((a, b) => {
    const x = new Date(a.date);
    const y = new Date(b.date);
    if (x > y) {
      return 1;
    }
    if (y > x) {
      return -1;
    }
    return 0;
  });
